import { render, staticRenderFns } from "./Bussiness.vue?vue&type=template&id=56c832c2&scoped=true&"
import script from "./Bussiness.vue?vue&type=script&lang=js&"
export * from "./Bussiness.vue?vue&type=script&lang=js&"
import style0 from "./Bussiness.vue?vue&type=style&index=0&id=56c832c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c832c2",
  null
  
)

export default component.exports